/* assets/all-reviews.js
 *
 * Hydrates sections/section-all-reviews.liquid from the HGI Reviews app proxy
 * (/apps/reviews?action=all). One fetch, then filter / sort / paginate
 * client-side. Filters combine: product AND star rating.
 *
 * Every piece of review content (titles, bodies, names) is user-generated and
 * is only ever written with textContent.
 */
(function () {
  'use strict';

  var STAR_PATH = 'M10 1.5l2.6 5.27 5.82.85-4.21 4.1.99 5.79L10 14.8l-5.2 2.71.99-5.79L1.58 7.62l5.82-.85z';
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var GWP_HANDLE = /gwp|sample/i;
  var GWP_TITLE = /\bGWP\b|sample with card/i;
  var LONG_BODY = 300;
  var CLIP_BODY = 270;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scrollBehavior = reduceMotion ? 'auto' : 'smooth';

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function fillStars(wrap, value, size, label) {
    wrap.textContent = '';
    for (var i = 1; i <= 5; i++) {
      var svg = document.createElementNS(SVG_NS, 'svg');
      svg.setAttribute('width', size);
      svg.setAttribute('height', size);
      svg.setAttribute('viewBox', '0 0 20 20');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      var path = document.createElementNS(SVG_NS, 'path');
      path.setAttribute('d', STAR_PATH);
      path.setAttribute('class', value >= i - 0.5 ? 'is-on' : 'is-off');
      svg.appendChild(path);
      wrap.appendChild(svg);
    }
    if (label) {
      wrap.setAttribute('role', 'img');
      wrap.setAttribute('aria-label', 'Rated ' + value + ' out of 5');
    } else {
      wrap.setAttribute('aria-hidden', 'true');
    }
    return wrap;
  }

  function stars(value, size, labelled, modifier) {
    var wrap = el('span', 'isc-rv-stars isc-rv-stars--' + size + (modifier ? ' ' + modifier : ''));
    return fillStars(wrap, value, size, labelled);
  }

  function fmtDate(iso) {
    var d = new Date(iso);
    // UK time: imported reviews are stamped at midnight UTC.
    return isNaN(d) ? '' : d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Europe/London' });
  }

  function imgUrl(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function initialOf(name) {
    return (name || '?').replace(/^limited[- ]edition:?\s*/i, '').trim().charAt(0).toUpperCase();
  }

  function productImage(product, width, alt) {
    if (product.image) {
      var img = el('img');
      img.src = imgUrl(product.image, width);
      img.alt = alt || '';
      img.loading = 'lazy';
      img.decoding = 'async';
      return img;
    }
    var initial = el('span', 'isc-rv-initial', initialOf(product.title));
    initial.setAttribute('aria-hidden', 'true');
    return initial;
  }

  var HONORIFIC = /^(mr|mrs|ms|miss|mx|dr|prof|sir|lady|dame)\.?$/i;
  var PARTICLE = /^(van|von|de|der|den|del|della|da|di|du|dos|das|do|la|le|st\.?|ter|ten)$/i;

  function titleCase(word) {
    return word.toLowerCase().replace(/(^|[-'’])(\S)/g, function (m, sep, ch) { return sep + ch.toUpperCase(); });
  }

  // "Tina Bowers" → "T. Bowers". Drops titles, keeps surname particles
  // ("T. dos Santos"), tidies all-lower / ALL-CAPS surnames. Single names
  // ("Tina", "KT") are shown as given.
  function displayName(raw) {
    var parts = String(raw || '').trim().split(/\s+/).filter(Boolean);
    while (parts.length > 2 && HONORIFIC.test(parts[0])) parts.shift();
    if (parts.length === 2 && HONORIFIC.test(parts[0])) return parts.join(' ');
    if (parts.length < 2) {
      var single = parts[0] || '';
      return single === single.toLowerCase() ? titleCase(single) : single;
    }
    var surname = parts[parts.length - 1];
    if (surname === surname.toLowerCase() || (surname.length > 2 && surname === surname.toUpperCase())) {
      surname = titleCase(surname);
    }
    var i = parts.length - 2;
    while (i > 0 && PARTICLE.test(parts[i])) surname = parts[i--] + ' ' + surname;
    return parts[0].charAt(0).toUpperCase() + '. ' + surname;
  }

  function reviewCountLabel(count) {
    return count === 1 ? '1 review' : count + ' reviews';
  }

  function init(root) {
    var cfg = {
      endpoint: root.getAttribute('data-endpoint') || '/apps/reviews',
      shop: root.getAttribute('data-shop') || '',
      minRating: parseInt(root.getAttribute('data-min-rating'), 10) || 3,
      pageSize: parseInt(root.getAttribute('data-page-size'), 10) || 12,
      rangeUrl: root.getAttribute('data-range-url') || '/collections/all',
      tickSrc: root.getAttribute('data-tick-src') || ''
    };

    function q(name) { return root.querySelector('[data-rv-' + name + ']'); }
    var refs = {
      avg: q('avg'),
      avgStars: q('avg-stars'),
      avgNavy: q('avg-navy'),
      avgStarsNavy: q('avg-stars-navy'),
      dist: q('dist'),
      clearRating: q('clear-rating'),
      rail: q('rail'),
      tileAll: q('tile-all'),
      total: q('total'),
      productCount: q('product-count'),
      panelAll: q('panel-all'),
      panelProduct: q('panel-product'),
      sort: q('sort'),
      heading: q('list-heading'),
      resultLabel: q('result-label'),
      cards: q('cards'),
      status: q('status'),
      moreWrap: q('more-wrap'),
      more: q('more')
    };

    var state = { product: null, rating: 0, sort: 'newest', limit: cfg.pageSize, expanded: {} };
    var model = null;
    var current = [];

    function url(product) { return '/products/' + product.handle; }

    function eligible(product) {
      return !!(product && product.available && product.handle &&
        !GWP_HANDLE.test(product.handle) && !GWP_TITLE.test(product.title || ''));
    }

    function build(data) {
      var products = {};
      (data.products || []).forEach(function (p) { products[p.id] = p; });

      var reviews = (data.reviews || []).filter(function (r) {
        return r.rating >= cfg.minRating && eligible(products[r.productId]);
      });

      var stats = {};
      var sum = 0;
      reviews.forEach(function (r) {
        var s = stats[r.productId] || (stats[r.productId] = { count: 0, sum: 0 });
        s.count++;
        s.sum += r.rating;
        sum += r.rating;
        r._time = Date.parse(r.createdAt) || 0;
        // Other products from the same order, minus GWP / samples / products no
        // longer on sale. Stars only when that rating is itself shown here.
        r._others = (r.alsoOrdered || []).filter(function (o) {
          return eligible(products[o.productId]);
        }).map(function (o) {
          return { id: o.productId, rating: o.rating != null && o.rating >= cfg.minRating ? o.rating : null };
        });
      });

      var list = Object.keys(stats).map(function (id) {
        var s = stats[id];
        s.avg = s.sum / s.count;
        return { id: id, product: products[id], count: s.count, avg: s.avg };
      }).sort(function (a, b) {
        return b.count - a.count || b.avg - a.avg || a.product.title.localeCompare(b.product.title);
      });

      return {
        products: products,
        reviews: reviews,
        stats: stats,
        list: list,
        total: reviews.length,
        avg: reviews.length ? sum / reviews.length : 0
      };
    }

    /* ---------- summary strip + navy panel ---------- */
    function renderSummary() {
      var avgLabel = model.total ? model.avg.toFixed(1) : '';
      var avgRounded = Math.round(model.avg * 10) / 10;
      refs.avg.textContent = avgLabel;
      refs.avgNavy.textContent = avgLabel;
      fillStars(refs.avgStars, avgRounded, 20, true);
      fillStars(refs.avgStarsNavy, avgRounded, 18, true);
      refs.total.textContent = String(model.total);
      refs.productCount.textContent = model.list.length + ' products reviewed';

      refs.dist.textContent = '';
      for (var n = 5; n >= cfg.minRating; n--) {
        var count = model.reviews.filter(function (r) { return r.rating === n; }).length;
        var pct = model.total ? Math.round(count / model.total * 100) : 0;
        var row = el('button', 'isc-rv-dist__row');
        row.type = 'button';
        row.setAttribute('data-rv-rating', n);
        row.setAttribute('aria-pressed', 'false');
        row.setAttribute('aria-label', n + ' star reviews: ' + count + '. Show only these reviews');
        row.title = 'Show only these reviews';
        row.appendChild(el('span', null, n + ' star'));
        var track = el('span', 'isc-rv-dist__track');
        var fill = el('span', 'isc-rv-dist__fill');
        track.appendChild(fill);
        row.appendChild(track);
        row.appendChild(el('span', 'isc-rv-dist__count', String(count)));
        refs.dist.appendChild(row);
        // Next frame so the width transition runs from 0.
        (function (f, w) { requestAnimationFrame(function () { f.style.width = w + '%'; }); })(fill, pct);
      }
    }

    function syncRating() {
      var rows = refs.dist.querySelectorAll('[data-rv-rating]');
      for (var i = 0; i < rows.length; i++) {
        var active = parseInt(rows[i].getAttribute('data-rv-rating'), 10) === state.rating;
        rows[i].classList.toggle('is-active', active);
        rows[i].setAttribute('aria-pressed', active ? 'true' : 'false');
      }
      refs.dist.parentNode.classList.toggle('has-filter', state.rating > 0);
      refs.clearRating.hidden = state.rating === 0;
    }

    /* ---------- product rail ---------- */
    function renderRail() {
      var frag = document.createDocumentFragment();
      model.list.forEach(function (entry) {
        var p = entry.product;
        var tile = el('button', 'isc-rv-tile');
        tile.type = 'button';
        tile.setAttribute('data-rv-tile', entry.id);
        tile.setAttribute('aria-pressed', 'false');
        tile.setAttribute('aria-label', p.title + ', rated ' + entry.avg.toFixed(1) + ' out of 5 from ' + reviewCountLabel(entry.count));

        var media = el('span', 'isc-rv-tile__media');
        media.appendChild(productImage(p, 460, ''));
        tile.appendChild(media);

        var body = el('span', 'isc-rv-tile__body');
        var name = el('span', 'isc-rv-tile__name', p.title);
        name.title = p.title;
        body.appendChild(name);
        var meta = el('span', 'isc-rv-tile__meta');
        meta.appendChild(stars(entry.avg, 12, false));
        meta.appendChild(el('span', 'isc-rv-tile__score', entry.avg.toFixed(1) + ' (' + entry.count + ')'));
        body.appendChild(meta);
        tile.appendChild(body);
        frag.appendChild(tile);
      });
      refs.rail.appendChild(frag);
    }

    function syncRail(reveal) {
      refs.tileAll.classList.toggle('is-active', !state.product);
      refs.tileAll.setAttribute('aria-pressed', state.product ? 'false' : 'true');
      var tiles = refs.rail.querySelectorAll('[data-rv-tile]');
      var activeTile = null;
      for (var i = 0; i < tiles.length; i++) {
        var active = tiles[i].getAttribute('data-rv-tile') === state.product;
        tiles[i].classList.toggle('is-active', active);
        tiles[i].setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active) activeTile = tiles[i];
      }
      if (reveal && activeTile) {
        var rail = refs.rail;
        var left = activeTile.offsetLeft;
        if (left < rail.scrollLeft || left + activeTile.offsetWidth > rail.scrollLeft + rail.clientWidth) {
          rail.scrollTo({ left: Math.max(0, left - 20), behavior: scrollBehavior });
        }
      }
    }

    /* ---------- aside panel ---------- */
    function renderPanel() {
      var panel = refs.panelProduct;
      if (!state.product) {
        panel.hidden = true;
        panel.textContent = '';
        refs.panelAll.hidden = false;
        return;
      }
      var p = model.products[state.product];
      var s = model.stats[state.product];
      panel.textContent = '';

      if (p.image) {
        var media = el('div', 'isc-rv-panel__media');
        media.appendChild(productImage(p, 640, p.title));
        panel.appendChild(media);
      }
      panel.appendChild(el('h3', 'isc-rv-panel__title', p.title));
      var rating = el('div', 'isc-rv-panel__rating');
      rating.appendChild(stars(Math.round(s.avg * 10) / 10, 14, true));
      rating.appendChild(el('span', null, s.avg.toFixed(1) + ' from ' + reviewCountLabel(s.count)));
      panel.appendChild(rating);

      var cta = el('div', 'isc-rv-panel__cta');
      var shop = el('a', 'isc-rv-btn isc-rv-btn--primary isc-rv-btn--full', 'Shop Now');
      shop.href = url(p);
      cta.appendChild(shop);
      panel.appendChild(cta);

      var back = el('button', 'isc-rv-textbtn', 'Back to all reviews');
      back.type = 'button';
      back.setAttribute('data-rv-clear-product', '');
      panel.appendChild(back);

      refs.panelAll.hidden = true;
      // Re-trigger the fade when switching between products.
      panel.hidden = true;
      void panel.offsetWidth;
      panel.hidden = false;
    }

    /* ---------- review list ---------- */
    function filtered() {
      var list = model.reviews.filter(function (r) {
        return (!state.product || r.productId === state.product) && (!state.rating || r.rating === state.rating);
      });
      var byDate = function (a, b) { return b._time - a._time; };
      if (state.sort === 'oldest') list.sort(function (a, b) { return a._time - b._time; });
      else if (state.sort === 'highest') list.sort(function (a, b) { return b.rating - a.rating || byDate(a, b); });
      else if (state.sort === 'lowest') list.sort(function (a, b) { return a.rating - b.rating || byDate(a, b); });
      else list.sort(byDate);
      return list;
    }

    function bodyText(r) {
      var body = r.body || '';
      if (body.length <= LONG_BODY || state.expanded[r.id]) return body;
      return body.slice(0, CLIP_BODY).replace(/\s+\S*$/, '') + '…';
    }

    function chip(other) {
      var p = model.products[other.id];
      var reviewed = !!model.stats[other.id];
      var node;
      if (reviewed) {
        node = el('button', 'isc-rv-chip');
        node.type = 'button';
        node.setAttribute('data-rv-pick', other.id);
        node.title = 'Read reviews for this product';
      } else {
        node = el('a', 'isc-rv-chip');
        node.href = url(p);
        node.title = 'View this product';
      }
      var media = el('span', 'isc-rv-chip__media');
      media.appendChild(productImage(p, 96, ''));
      node.appendChild(media);
      var text = el('span', 'isc-rv-chip__text');
      text.appendChild(el('span', 'isc-rv-chip__name', p.title));
      if (other.rating) text.appendChild(stars(other.rating, 10, true));
      node.appendChild(text);
      return node;
    }

    function card(r) {
      var p = model.products[r.productId];
      var count = model.stats[r.productId].count;
      var article = el('article', 'isc-rv-card');
      article.setAttribute('data-rv-review', r.id);

      var head = el('div', 'isc-rv-card__product');
      var thumb = el('button', 'isc-rv-card__thumb');
      thumb.type = 'button';
      thumb.title = 'All reviews for this product';
      thumb.setAttribute('aria-label', 'All reviews for ' + p.title);
      thumb.setAttribute('data-rv-pick', r.productId);
      thumb.appendChild(productImage(p, 160, ''));
      head.appendChild(thumb);

      var info = el('div', 'isc-rv-card__pinfo');
      var title = el('a', 'isc-rv-card__ptitle', p.title);
      title.href = url(p);
      info.appendChild(title);
      var actions = el('div', 'isc-rv-card__actions');
      var shop = el('a', 'isc-rv-card__shop', 'Shop Now');
      shop.href = url(p);
      shop.setAttribute('aria-label', 'Shop Now: ' + p.title);
      actions.appendChild(shop);
      var all = el('button', 'isc-rv-card__all', count === 1 ? 'The only review' : 'All ' + count + ' reviews');
      all.type = 'button';
      all.setAttribute('data-rv-pick', r.productId);
      actions.appendChild(all);
      info.appendChild(actions);
      head.appendChild(info);
      article.appendChild(head);

      var meta = el('div', 'isc-rv-card__meta');
      meta.appendChild(stars(r.rating, 14, true));
      var date = el('time', 'isc-rv-card__date', fmtDate(r.createdAt));
      date.dateTime = r.createdAt;
      meta.appendChild(date);
      article.appendChild(meta);

      if (r.title) article.appendChild(el('h3', 'isc-rv-card__title', r.title));
      var bodyId = 'IscRvBody-' + r.id;
      var body = el('p', 'isc-rv-card__body', bodyText(r));
      body.id = bodyId;
      article.appendChild(body);
      if ((r.body || '').length > LONG_BODY) {
        var open = !!state.expanded[r.id];
        var toggle = el('button', 'isc-rv-card__more', open ? 'Show less' : 'Read more');
        toggle.type = 'button';
        toggle.setAttribute('data-rv-toggle', r.id);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute('aria-controls', bodyId);
        article.appendChild(toggle);
      }

      var footer = el('div', 'isc-rv-card__footer');
      footer.appendChild(el('span', 'isc-rv-card__name', displayName(r.reviewerName)));
      if (r.verifiedBuyer) {
        var verified = el('span', 'isc-rv-card__verified');
        if (cfg.tickSrc) {
          var tick = el('img');
          tick.src = cfg.tickSrc;
          tick.width = 12;
          tick.height = 12;
          tick.alt = '';
          verified.appendChild(tick);
        }
        verified.appendChild(document.createTextNode('Verified buyer'));
        footer.appendChild(verified);
      }
      article.appendChild(footer);

      if (r._others.length) {
        var also = el('div', 'isc-rv-card__also');
        also.appendChild(el('div', 'isc-rv-card__also-label',
          r._others.length === 1 ? 'Also ordered' : 'Also ordered (' + r._others.length + ')'));
        var chips = el('div', 'isc-rv-chips');
        r._others.forEach(function (o) { chips.appendChild(chip(o)); });
        also.appendChild(chips);
        article.appendChild(also);
      }
      return article;
    }

    function appendCards(from, to) {
      var frag = document.createDocumentFragment();
      current.slice(from, to).forEach(function (r) { frag.appendChild(card(r)); });
      refs.cards.appendChild(frag);
    }

    function syncListMeta() {
      var shown = Math.min(state.limit, current.length);
      var heading = 'All reviews';
      if (state.product) heading = model.products[state.product].title;
      else if (state.rating) heading = state.rating + '-star reviews';
      refs.heading.textContent = heading;
      refs.resultLabel.textContent = 'Showing ' + shown + ' of ' + current.length;
      refs.moreWrap.hidden = current.length <= state.limit;
      refs.status.hidden = current.length > 0;
      refs.status.textContent = 'No reviews match this selection yet.';
    }

    function renderList() {
      current = filtered();
      refs.cards.textContent = '';
      appendCards(0, state.limit);
      syncListMeta();
    }

    /* ---------- actions ---------- */
    function bringListIntoView() {
      var head = refs.heading.parentNode;
      if (head.getBoundingClientRect().top < 0) {
        head.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
      }
      refs.heading.focus({ preventScroll: true });
    }

    function selectProduct(id, opts) {
      opts = opts || {};
      state.product = opts.toggle && state.product === id ? null : id;
      state.limit = cfg.pageSize;
      syncRail(!!state.product && !opts.fromRail);
      renderPanel();
      renderList();
      if (opts.fromList) bringListIntoView();
    }

    function setRating(n) {
      state.rating = state.rating === n ? 0 : n;
      state.limit = cfg.pageSize;
      syncRating();
      renderList();
    }

    function toggleBody(id, button) {
      state.expanded[id] = !state.expanded[id];
      var r = current.filter(function (x) { return x.id === id; })[0];
      var article = button.closest('[data-rv-review]');
      if (!r || !article) return;
      article.querySelector('.isc-rv-card__body').textContent = bodyText(r);
      button.textContent = state.expanded[id] ? 'Show less' : 'Read more';
      button.setAttribute('aria-expanded', state.expanded[id] ? 'true' : 'false');
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t || !root.contains(t)) return;

      if (t.hasAttribute('data-rv-rail-prev') || t.hasAttribute('data-rv-rail-next')) {
        var dir = t.hasAttribute('data-rv-rail-prev') ? -1 : 1;
        refs.rail.scrollBy({ left: dir * refs.rail.clientWidth * 0.8, behavior: scrollBehavior });
        return;
      }
      if (!model) return;

      if (t.hasAttribute('data-rv-rating')) return setRating(parseInt(t.getAttribute('data-rv-rating'), 10));
      if (t.hasAttribute('data-rv-clear-rating')) {
        state.rating = 0;
        state.limit = cfg.pageSize;
        syncRating();
        renderList();
        return;
      }
      if (t.hasAttribute('data-rv-tile')) return selectProduct(t.getAttribute('data-rv-tile'), { toggle: true, fromRail: true });
      if (t.hasAttribute('data-rv-tile-all')) return selectProduct(null, { fromRail: true });
      if (t.hasAttribute('data-rv-clear-product')) {
        selectProduct(null);
        refs.tileAll.focus({ preventScroll: true });
        return;
      }
      if (t.hasAttribute('data-rv-pick')) return selectProduct(t.getAttribute('data-rv-pick'), { fromList: true });
      if (t.hasAttribute('data-rv-toggle')) return toggleBody(t.getAttribute('data-rv-toggle'), t);
      if (t.hasAttribute('data-rv-more')) {
        var from = state.limit;
        state.limit += cfg.pageSize;
        appendCards(from, state.limit);
        syncListMeta();
      }
    });

    refs.sort.addEventListener('change', function () {
      if (!model) return;
      state.sort = refs.sort.value;
      state.limit = cfg.pageSize;
      renderList();
    });

    var endpoint = cfg.endpoint + '?action=all&shop=' + encodeURIComponent(cfg.shop);
    fetch(endpoint, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        model = build(data);
        renderSummary();
        syncRating();
        renderRail();
        syncRail(false);
        renderList();
      })
      .catch(function (err) {
        console.error('[all-reviews] could not load reviews', err);
        refs.status.hidden = false;
        refs.status.textContent = 'Reviews could not be loaded. Please refresh the page to try again.';
      });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-isc-all-reviews]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].__iscRv) continue;
      roots[i].__iscRv = true;
      init(roots[i]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
